import Input from '@dealroadshow/uikit-input';
import PhoneInput from '@dealroadshow/uikit-input/PhoneInput';
import { Field } from '@framework/ui/Organisms/FinalForm';
import styles from '../callFormSteps.module.scss';

const YourDetailsFields = () => (
  <div className={ styles.inputWrapper }>
    <div className={ styles.smallInput }>
      <Field
        name="firstName"
        label="First Name"
        component={ Input }
        placeholder="First Name"
        dataTest="detailFormFirstNameInput"
      />
    </div>
    <div className={ styles.smallInput }>
      <Field
        name="lastName"
        label="Last Name"
        component={ Input }
        placeholder="Last Name"
        dataTest="detailFormLastNameInput"
      />
    </div>
    <div className={ styles.smallInput }>
      <Field
        name="corporateEmail"
        type="email"
        label="Corporate Email"
        component={ Input }
        placeholder="john@acme.com"
        dataTest="detailFormCorporateEmailInput"
      />
    </div>
    <div className={ styles.smallInput }>
      <Field
        isFinalForm
        name="phoneNumber"
        label="Phone Number"
        component={ PhoneInput }
        dataTest="detailFormPhoneInput"
      />
    </div>
  </div>
);

export default YourDetailsFields;
